import { Component, OnInit } from '@angular/core';

import { SOCIAL_MEDIA } from '@shared/constants/socials';
import { GetMeNotifiedService, AuthService } from '@shared/services';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { PrivacyPolicyComponent } from '../modals/privacy-policy/privacy-policy.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { TermsOfUseComponent } from '../modals/terms-of-use/terms-of-use.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isUserLogin: boolean = false;
  copyrightYear = new Date().getFullYear();
  hideSection: boolean = false;
  modalRef: BsModalRef;
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-sm'
  };

  constructor(
    private _getMeNotified: GetMeNotifiedService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private _authService: AuthService
  ) {
    route.events.subscribe(val => {
      if (val instanceof NavigationEnd === true) {
        if (this.route.url === '/app/home') {
          this.hideSection = true;
        } else {
          this.hideSection = false;
        }
        const currentUser =
          JSON.parse(localStorage.getItem('currentUser')) || {};
        this.isUserLogin = (currentUser && currentUser.isLogin) || false;
      }
    });
  }

  ngOnInit() {}

  getMeNotified() {
    this._getMeNotified.toggle();
    this._getMeNotified.setPreOrderStatus(false);
  }

  openFooterNavigation(event: any) {
    const className = event.srcElement.parentElement.className;
    event.srcElement.parentElement.className = `${className} active`;
  }

  openSocialLink(social) {
    switch (social) {
      case SOCIAL_MEDIA.FACEBOOK:
        window.open('https://www.facebook.com/partbnb', '_blank');
        break;
      case SOCIAL_MEDIA.TWITTER:
        window.open('https://twitter.com/partbnb', '_blank');
        break;
      case SOCIAL_MEDIA.INSTAGRAM:
        window.open('https://www.instagram.com/partbnb', '_blank');
        break;
      case SOCIAL_MEDIA.LINKEDIN:
        window.open('https://www.linkedin.com/company/partbnb/', '_blank');
        break;
      default:
    }
  }

  showPrivacyPolicyModal() {
    this.modalConfig.ignoreBackdropClick = false;
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(
      PrivacyPolicyComponent,
      this.modalConfig
    );
  }

  showTermsOfUseModal() {
    this.modalConfig.ignoreBackdropClick = false;
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(
      TermsOfUseComponent,
      this.modalConfig
    );
  }

  goToMyProfile() {
    const moduleName = this.activatedRoute.snapshot.data.module;
    if (moduleName === 'mainApp') {
      this.route.navigate(['/app/my-profile']);
    } else {
      this.route.navigate(['/dashboard/my-profile']);
    }
  }

  logout() {
    this._authService.logout();
    location.reload(true);
  }
}
